import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=66d6eefa"
import script from "./PasswordForm.vue?vue&type=script&lang=ts"
export * from "./PasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports